<template>
  <div :class="$style.topbar">
    <div class="mr-auto">
    </div>
    <!--
    <div class="mr-4 d-none d-sm-block">
      <cui-actions />
    </div>-->
    <div class="float-right">
      <cui-user-menu />
    </div>
  </div>
</template>

<script>
import CuiUserMenu from './UserMenu'
// import CuiActions from './Actions'
export default {
  components: {
    CuiUserMenu,
    // CuiActions,
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
